@if (isLoading()) {
  <aw-loading-animation
    [entityType]="EEntityType.ticketConfiguration"
    [relationType]="
      RelationType.loadingDirectTicketOwnerData
    "></aw-loading-animation>
}

@if (!isLoading() && ticketConfiguration()) {
  <div class="flex flex-col gap-6 md:flex-row">
    <div class="flex w-full flex-col gap-4 md:w-2/3">
      <aw-section
        [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
        [testIdAffix]="'ticket-option-configuration-page-section'">
        @for (
          product of shoppingCartService.ticketsInCart();
          track product;
          let outerIndex = $index
        ) {
          @for (
            ticket of ticketOwnerDataForms.controls[$index].controls;
            track ticket;
            let innerIndex = $index
          ) {
            <aw-direct-ticket-owner-data-form
              (onChange)="updateFormArray()"
              [id]="
                product.productForm!.value!.tariffGroup!.name!
                  | appendTestId: outerIndex + '-' + innerIndex
              "
              [ticketName]="product.productForm!.value!.tariffGroup!.name!"
              [ticketOwnerForm]="ticket"></aw-direct-ticket-owner-data-form>
          }
        }
        @if (
          auth.isLoggedIn() &&
          hasAlternativeTicketOwnerOrCompanions() &&
          isAlternativeTicketOwnerActive()
        ) {
          <aw-checkbox
            id="save-fellow-travelers"
            [label]="
              textStore.texts()
                | filterTexts
                  : ERelationType.saveFellowTravelersLabel
                  : EEntityType.ticketConfiguration
                | language
            "
            [formControl]="
              shoppingCartService.orderOptionsForm.controls
                .shouldSaveFellowTravelers
            "></aw-checkbox>
        }
      </aw-section>
    </div>

    <aw-direct-ticket-configuration-shopping-cart
      class="fixed bottom-0 left-0 z-20 w-full md:relative md:w-1/3"
      [page]="EPage.Configuration"
      [attr.data-testid]="'personal-data-configuration-page-shopping-cart'"
      [isDisabled]="!ticketOwnerDataForms.valid"
      (onButtonClick)="
        proceedToCheckout()
      "></aw-direct-ticket-configuration-shopping-cart>
  </div>
}
